module.exports = __webpack_public_path__ + "static/img/swagger.78429129.svg";